import { render, staticRenderFns } from "./AgentsTcRecordList.vue?vue&type=template&id=40217544&"
import script from "./AgentsTcRecordList.vue?vue&type=script&lang=js&"
export * from "./AgentsTcRecordList.vue?vue&type=script&lang=js&"
import style0 from "./AgentsTcRecordList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports